import { useEffect, useState } from "react";
import { BoardProductCard } from "../components/BoardProductCard";
import { EmptyState } from "../components/EmptyState";
import { searchFinds } from "../lib/api";
import type { DiscoveryProduct } from "../lib/types";

export function SearchRoute({ query }: { query: string }) {
  const [finds, setFinds] = useState<DiscoveryProduct[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setFinds([]);
    (async () => {
      const data = await searchFinds(query);
      if (cancelled) return;
      setFinds(data?.finds ?? []);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [query]);

  return (
    <section
      id="search-view"
      className="w-full px-4 pb-4 grid gap-[1.8rem] pt-[2.4rem] flex-1 min-h-0 overflow-auto content-start"
    >
      <div>
        <h1 className="m-0 font-bold tracking-[-0.05em] leading-[0.96] text-[clamp(1.9rem,5vw,3.4rem)]">
          Search results
        </h1>
        <p className="text-muted m-0 mt-2">"{query}"</p>
      </div>

      <div
        id="search-grid"
        className="grid grid-cols-[repeat(auto-fill,minmax(240px,1fr))] gap-4"
      >
        {loading ? (
          <EmptyState text="Searching..." />
        ) : finds.length === 0 ? (
          <EmptyState text="No finds found." />
        ) : (
          finds.map((find) => (
            <BoardProductCard
              key={find.id}
              product={find}
            />
          ))
        )}
      </div>
    </section>
  );
}
